module.exports = __webpack_public_path__ + "images/referenzen/werbespot/tesa_powerbond.jpg";